import React, { useState, useEffect } from "react";
import "./index.less";
import {
  getPropsNames,
  get_properties_from_cas,
  get_T_dep_properties_from_cas,
  get_Liquid_Thermal_Conductivity_Sensitivity,
  get_Gas_Thermal_Conductivity_Sensitivity,
  get_Ideal_Gas_Heat_Capacity_Sensitivity,
  get_Solid_Heat_Capacity_Sensitivity,
  get_Heat_of_Vaporization_Sensitivity,
  get_Molar_Liquid_Density_Sensitivity,
  get_Molar_Solid_Density_Sensitivity,
  get_Liquid_Viscosity_Sensitivity,
  get_Gas_Viscosity_Sensitivity,
  get_Saturation_Vapor_Pressure_Gas_Liquid_Sensitivity,
  get_Saturation_Vapor_Pressure_Gas_Solid_Sensitivity,
  get_Surface_Tension_Sensitivity,
  get_Solubility_in_Water_Sensitivity,
} from "@/services/propsApi";
import ModelViewer from "@/Components/3DViewer";
import { rebuildFormula } from "@/config/func";
import { props_T } from "./const";
import { Button, Input, Space } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import S_charts from './S_charts';

const funcList = {
  get_Liquid_Thermal_Conductivity_Sensitivity,
  get_Gas_Thermal_Conductivity_Sensitivity,
  get_Ideal_Gas_Heat_Capacity_Sensitivity,
  get_Solid_Heat_Capacity_Sensitivity,
  get_Heat_of_Vaporization_Sensitivity,
  get_Molar_Liquid_Density_Sensitivity,
  get_Molar_Solid_Density_Sensitivity,
  get_Liquid_Viscosity_Sensitivity,
  get_Gas_Viscosity_Sensitivity,
  get_Saturation_Vapor_Pressure_Gas_Liquid_Sensitivity,
  get_Saturation_Vapor_Pressure_Gas_Solid_Sensitivity,
  get_Surface_Tension_Sensitivity,
  get_Solubility_in_Water_Sensitivity,
};

// const tableData = [
//   { parameter: "压力", value: 18, unit: "bar" },
//   { parameter: "常压泡点", value: 217, unit: "°C" },
//   { parameter: "密度", value: 0.85, unit: "g/cm³" },
//   { parameter: "粘度", value: 1.2, unit: "mPa·s" },
//   { parameter: "流量", value: 50, unit: "m³/h" },
//   { parameter: "温度", value: 25, unit: "°C" },
//   { parameter: "pH值", value: 7.2, unit: "" },
//   { parameter: "电导率", value: 500, unit: "μS/cm" },
//   { parameter: "溶解氧", value: 8.5, unit: "mg/L" },
//   { parameter: "浊度", value: 0.5, unit: "NTU" },
//   { parameter: "总磷", value: 0.02, unit: "mg/L" },
//   { parameter: "总氮", value: 0.5, unit: "mg/L" },
//   { parameter: "COD", value: 30, unit: "mg/L" },
//   { parameter: "BOD", value: 10, unit: "mg/L" },
//   { parameter: "SS", value: 5, unit: "mg/L" },
//   { parameter: "硬度", value: 120, unit: "mg/L" },
//   { parameter: "碱度", value: 80, unit: "mg/L" },
//   { parameter: "余氯", value: 0.3, unit: "mg/L" },
//   { parameter: "氨氮", value: 0.1, unit: "mg/L" },
// ];
const ResponsiveParameterTable = ({
  // data = tableData,
  // minWidthForSingleRow = 600,
  source,
}: any) => {
  // const [isSingleRowMode, setIsSingleRowMode] = useState(true);
  // const [tableContainerRef, setTableContainerRef] = useState<HTMLDivElement | null>(null);
  const [propsNames, setPropsNames] = useState<any>(null);
  const [dataSource, setDataSource] = useState<any>(null);
  const [dataSource_T, setDataSource_T] = useState<any>(null);
  const [T, setT] = useState<any>(25); //默认温度
  const [isSettingT, setIsSettingT] = useState<any>(false);
  const [T_range, setT_range] = useState<any>([25, 200]); //温度范围
  const [T_step, setT_step] = useState<any>(1); //温度范围步长
  const [curType, setCurType] = useState<any>(null); //当前类型
  const [s_data,setS_data] = useState<any>(null); //敏感度数据

  // useEffect(() => {
  //   const checkTableWidth = () => {
  //     if (tableContainerRef) {
  //       setIsSingleRowMode(tableContainerRef.clientWidth <= minWidthForSingleRow);
  //     }
  //   };

  //   checkTableWidth();

  //   const handleResize = () => {
  //     checkTableWidth();
  //   };

  //   window.addEventListener("resize", handleResize);

  //   return () => {
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, [tableContainerRef, minWidthForSingleRow]);

  useEffect(() => {
    getPropsNames().then((r) => {
      let names: any = {};
      r.data.response.data.map((item: any) => {
        names[item.code] = item;
      });
      setPropsNames(names);
    });
  }, []);

  useEffect(() => {
    if(source && curType){
      funcList[`get_${curType}_Sensitivity`](source.cas_code, T_range[0],T_range[1],T_step).then((r:any)=>{
        setS_data(r.data.data)
      })
    }
  }, [curType,T_step,T_range]);

  useEffect(() => {
    if (source) {
      get_properties_from_cas(source.cas_code).then((r) => {
        console.log("r.data.response.data", r);
        setDataSource(r.data.data);
      });
      get_T_dep_properties_from_cas(source.cas_code, T).then((r) => {
        const d:any=r.data.data

        const keys:any=Object.keys(d)
        for(let n=0;n<keys.length;n++){
          if(d[keys[n]]){
            setCurType(keys[n])
            break;
          }
        }
        console.log("r.data.response.data", r);

        setDataSource_T(d);
      });
    }
  }, [source, T]);

  const showProps = () => {
    if (dataSource && propsNames) {
      return (
        <ul className="propsListShow mt2">
          {Object.keys(dataSource).map((key: any, index: any) => {
            if (key !== "MW") {
              if (propsNames[key] && dataSource[key]) {
                return (
                  <li key={index}>
                    <span className="desc">{propsNames[key].alias}</span>：
                    <span className="value">{dataSource[key] ? dataSource[key] : "-"}</span>
                    {propsNames[key].Unit ? (
                      <span className="unit">{propsNames[key].Unit}</span>
                    ) : (
                      ""
                    )}
                  </li>
                );
              } else {
                return "";
              }
            }
          })}
        </ul>
      );
    } else {
      return "";
    }
  };

  const changeT = () => {
    const i: any = document.getElementById("Tinput");
    setT(i.value);
    setIsSettingT(false);
    i.blur()
  };

  //绑定快捷键提交更新flow name
  const keySubUpdateT = (e: any) => {
    if (e.key === "Enter") {
      changeT();
    }
    if (e.key === "Escape") {
      setIsSettingT(false);
    }
  };

  const changeTRange=(e:any)=>{
    const lt: any = document.getElementById("lt");
    const ht: any = document.getElementById("ht");
    if (e.key === "Enter") {
      setT_range([Number(lt.value),Number(ht.value)])
    }
  }

  return (
    <div className="responsive-table-container">
      <div className="mainC">
        <div className="mpline">
          <div className="mpll">
            <ul className="plist">
              <li>
                中文名：<b>{source?.name}</b>
              </li>
              <li>
                英文名：<b>{source?.ename}</b>
              </li>
              <li>
                分子式：<b>{source ? rebuildFormula(source.formula) : ""}</b>
              </li>
              <li>
                CAS&nbsp;号：<b>{source?.cas_code}</b>
              </li>
              <li>
                类&nbsp;&nbsp;&nbsp;&nbsp;别：<b>{source?.type}</b>
              </li>
              <li className="val">
                分子量：<b>{dataSource?.MW}</b>
              </li>
            </ul>
          </div>
          <div className="mplr">
            {dataSource?<ModelViewer
              filePath={dataSource.sdf}
              height="275px"
              width="100%"
              // disLenged={true}
              bgColor="rgba(2, 77, 196,0.03)"
              pngImg={dataSource.svg}
              // refresh={false}
            />:''}
            
          </div>
        </div>
      </div>

      {showProps()}
      <div className="showTData mt2">
        <div className="showtTitle">
          <div className="t2">与温度相关的物性：</div>
          <div className="settings">
            {/* {isSettingT ? (
              <Space>
                <Input type="text" defaultValue={T} style={{width:'10rem'}} id="Tinput" onKeyUp={keySubUpdateT} suffix={<span className="fieldUnit">°C</span>} />
                <Button size="small" onClick={changeT} type="primary">
                  <div className="icon ok"></div>
                </Button>
                <Button
                  size="small"
                  onClick={async () => {
                    await setIsSettingT(false);
                  }}
                >
                  <div className="icon cancel off"></div>
                </Button>
              </Space>
            ) : (
              <div
                className="showTarea"
                onClick={async () => {
                  await setIsSettingT(true);
                  const i: any = document.getElementById("Tinput");
                  i.value = T;
                  i.focus();
                }}
              >
                <Space>
                  <div className="curT">{T}</div>°C
                  <SettingOutlined />
                </Space>
              </div>
            )} */}
            <Space>
                <div style={{marginLeft:'2rem'}}>当前温度：</div><Input type="text" defaultValue={T} style={{width:'12rem',fontWeight:'bold',fontSize:'2rem',padding:'0 1rem'}} id="Tinput" onKeyUp={keySubUpdateT} suffix={<span className="fieldUnit">°C</span>} />
                {/* <Button size="small" onClick={changeT} type="primary">
                  <div className="icon ok"></div>
                </Button>
                <Button
                  size="small"
                  onClick={async () => {
                    await setIsSettingT(false);
                  }}
                >
                  <div className="icon cancel off"></div>
                </Button> */}
              </Space>
          </div>
        </div>

        <div className="mpline mt1" style={{width:'100%',border:'1px solid #ccc' }}>
          <div className="mpll" style={{width: "450px"}}>
            <ul className="plist">
              {dataSource_T
                ? Object.keys(dataSource_T).map((key: any, index: any) => {
                    return (
                      <li
                        key={index}
                        className={key === curType ? "act active" : "act"}
                        onClick={() => {
                          setCurType(key);
                        }}
                      >
                        <div className="pname">{props_T[key]?.name || key}：</div>
                        <b>{dataSource_T[key] ? dataSource_T[key] : "-"}</b>
                        <div className="unit" style={{ marginTop: "0.5rem" }}>
                          {props_T[key]?.unit || ""}
                        </div>
                      </li>
                    );
                  })
                : ""}
            </ul>
          </div>
          <div className="mplr"
          style={{marginLeft:'3rem',width:'calc(100% - 450px)',padding:'1rem 2rem'}}
          >
            <Space>
            <div className="t2">{source?.name} {source ? rebuildFormula(source.formula) : ""} 温度灵敏度计算：</div>
            <Space>
              <div>当前温度范围：</div>
              <Space>
              <input type="text" id='lt' onKeyUp={changeTRange} defaultValue={T_range[0]} className="n1"/>
              ~
              <input type="text" id='ht' onKeyUp={changeTRange} defaultValue={T_range[1]}  className="n1"/>
              °C
              </Space>
            </Space>
            </Space>
            {s_data?<S_charts title={props_T[curType].name} unit={props_T[curType].unit} source={s_data}/>:''}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResponsiveParameterTable;
